<template>
 <div>
   <b-row>
    <b-col md="1">
    </b-col>
    <b-col md="10">
      <b-card md="1" bg-variant="none"> {{description}}</b-card>
    </b-col>
    <b-col md="1">
    </b-col>
   </b-row>
   <br>
    <b-row>
      <b-col md="1">
      </b-col>
      <b-col md="10">
        <feature-card :data_item="ams_data"></feature-card>
      </b-col>
      <b-col md="1">
        <data-navagations
          :can_update="isAdminPath"
          @update="doUpdate"
          @cancel="doCancel"
          @help="doHelp"
        ></data-navagations>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {http_v1} from '@/axios'
import {ADMIN_PATH, FEATURES, amsApiResourcePath} from '@/ams_route.js'
import FeatureCard from './FeatureCard.vue'
import DataNavagations from './DataNavagations.vue'

export default {
  components: {
    FeatureCard,
    DataNavagations
  },
  props: {
    id: {
      Type: String
    },
    api_path: {
      Type: String
    }
  },
  data () {
    return {
      ams_type: FEATURES,
      ams_data: {},
      description: ''
    }
  },
  computed: {
    isAdminPath() {
      return this.apiPath() == ADMIN_PATH
    }
  },
  methods: {
    apiPath () {
      return this.paramApiPath() || ADMIN_PATH
    },
    paramApiPath() {
      // Note $route and $router are not the same
      return this.api_path || this.$route.query?.api_path
    },
    apiResourcePath() {
      return amsApiResourcePath(this.apiPath(), FEATURES) + '/' + this.id
    },
    doCancel() {
      this.$router.go(-1)
    },
    doUpdate() {
      this.$router.push( {path: '/' + this.ams_type + '/' + this.id + '/update'})
    },
    doHelp() {
      this.$router.push( {path: '/references/Feature/information/' + this.id})
    }
  },
  mounted () {
    http_v1.get(this.apiResourcePath(), {
    }).then(response => {
      if( response.data) {
        this.ams_data = response.data.data
        // this.$emit('gotAttrs', this.ams_data?.attributes, this.description)
      }
    }).catch(error => {
      if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
  }
}
</script>

